import React from 'react';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/shared/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';

interface AdminScheduleInfoProps {
  stepNumber?: number;
}

export const AdminScheduleInfo = ({
  stepNumber = 2
}: AdminScheduleInfoProps) => {
  const { t } = useTranslation();

  return (
    <SimpleFormStep
      mode={FormStepMode.Outlined}
      stepNumber={stepNumber}
      stepTitle={t(
        'containers.deposit_money.topup_tab.form.schedule.title_lounari'
      )}
      pr="70px"
    >
      <Box
        width={500}
        id="deposit_money_admin_topup_step_two_schedule"
        fontSize={16}
        fontWeight={400}
        position="relative"
        top={3}
      >
        {t('containers.deposit_money.topup_tab.form.schedule.immediate')}
      </Box>
    </SimpleFormStep>
  );
};
